<script lang='ts'>
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'

export default defineComponent({
  name: 'MsFooter',
  props: {
    showCancel: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const router = useRouter()

    function cancel() {
      router.back()
    }

    return {
      cancel,
    }
  },
})
</script>

<template>
  <div class="footer-container">
    <slot />
    <el-button v-if="showCancel" plain @click="cancel">
      取消
    </el-button>
  </div>
</template>

<style lang='scss' scoped>
.footer-container {
  position: fixed;
  z-index: 200;
  right: 0;
  bottom: 0;
  left: $side-width;
  height: $footer-height;
  width: 100%;
  background: white;
  display: flex;
  align-items: center;
  border-top: 0.5px solid $border-color-base;
  padding: 0 $space-md;

  ::v-deep(.el-button) {
    min-width: 88px;
  }
}
</style>
